export default "__VITE_ASSET__B4Y$Es4e__"